import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from '../../../../../../core/services/localStorage.service';

@Injectable({
  providedIn: 'root',
})
export class ObsoleteProductService {
  protected showObsolete$ = new BehaviorSubject<boolean>(false);

  SHOW_OBSOLETE_PRODUCTS = 'ShowObsoleteProducts';

  constructor(private localStorageService: LocalStorageService) {}

  setStatus(status: boolean) {
    this.localStorageService.setItem(this.SHOW_OBSOLETE_PRODUCTS, status.toString());
    this.showObsolete$.next(status);
  }

  getStatus() {
    return this.showObsolete$.asObservable();
  }
}
